import * as Yup from 'yup'

import CallToActionButton from 'components/common/CallToActionButton/CallToActionButton'
import React from 'react'
import SimpleInput from 'components/common/SimpleInput/SimpleInput'
import { THEME_DARK } from 'constants.js'
import { useForm } from 'hooks/use-form'
import { useStyles } from './styles'

const validationSchema = Yup.object().shape({
    email: Yup.string()
        .email('Please enter a valid email address')
        .required('Please provide a display name'),
})

export const CountdownEndForm = ({ artist, priorityListUser, createPriorityListUser, creationError, ipv4 }) => {
    const classes = useStyles()
    const submitEmailHandler = async ({ email }) =>
        await createPriorityListUser(artist._id, { email: email, waitlist: true, ipv4 })

    const { values, handleSubmit, eventHandlers, errors, touched } = useForm(
        'countdownend',
        { email: '' },
        submitEmailHandler,
        validationSchema,
    )

    const renderFormContent = () => {
        if (priorityListUser && priorityListUser.waitlist) {
            //User successfully joined waitlist
            return (
                <div className={classes.successMsgContainer}>
                    <p className={classes.successMsg}>You're on the waitlist!</p>
                </div>
            )
        } else {
            return (
                <form className={classes.formInline} onSubmit={handleSubmit}>
                    <SimpleInput
                        error={creationError || (touched.email && errors.email)}
                        onChange={eventHandlers.email}
                        value={values.email}
                        label=""
                        placeholder="Email"
                        className={classes.formCtrlInline}
                        themeColor={THEME_DARK}
                    />
                    <CallToActionButton onClick={handleSubmit} display="inline" type="white" text="Join wait list" />
                    <input style={{ display: 'none' }} type="submit" />
                </form>
            )
        }
    }

    return (
        <div className={classes.container}>
            <p className={classes.headline}>Priority List is closed.</p>
            <p className={classes.headlineDesc}>While the Priority List is closed, you can still join the waitlist.</p>

            <p className={classes.emailDisclaimer}>
                We'll send you event updates and keep you in the loop. We're rooting for you.
            </p>

            {renderFormContent()}
        </div>
    )
}

export default React.memo(CountdownEndForm)
